export default __webpack_public_path__ + "static/media/NewYearResolution_11.80040aa4.png";